// 回合計時器的純設定解析（不依賴 Phaser，供設定與測試共用）。

export const DEFAULT_TURN_TIMEOUT_SEC = 15; // 元件呼叫端省略秒數時的預設值

/** 省略才套預設秒數；明確傳 null 必須保留「不催促」語意。 */
export const resolveTurnTimerDuration = (durationSec: number | null | undefined): number | null =>
  durationSec === undefined ? DEFAULT_TURN_TIMEOUT_SEC : durationSec;
